/******************************************************************************
 * Created Date: Monday August 16th 2021                                      *
 * Author: Derik K.                                                           *
 * -----                                                                      *
 * Last Modified: Sun Sep 05 2021                                             *
 * Modified By: Sean W.                                                       *
 * -----                                                                      *
 * File: /src/components/common/OrganizationSelect.js                         *
 * Copyright (c) 2021 Kuva                                                    *
 ******************************************************************************/

import React, { useState } from "react";
import { Avatar, Typography, Popover } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { useOrganizations } from "../../contentProviders/OrganizationsContextProvider";

import OrganizationTree from "./OrganizationTree";

const OrganizationSelect = ({ value: org, onChange, showAll }) => {
  const { selectedOrg } = useOrganizations();
  org || (org = selectedOrg);

  const [anchor, setAnchor] = useState(null);
  const handleMenu = event => {
    setAnchor(event.currentTarget);
  };
  const handleClose = () => {
    setAnchor(null);
  };
  const handleSelect = org => {
    onChange?.(org);
    handleClose();
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "10px 15px",
          borderRadius: 4
        }}
        onClick={handleMenu}
      >
        <Avatar src={org?.logoURL} style={{ marginRight: 10 }} />
        <Typography variant="h5">
          {" "}
          {org?.orgname || org?.id || "Select organization"}{" "}
        </Typography>
        <ExpandMoreIcon />
      </div>
      <Popover
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
        PaperProps={{
          style: {
            width: 300,
            maxHeight: "80vh",
            backgroundColor: "#242E3B"
          }
        }}
      >
        <OrganizationTree onSelect={handleSelect} showAll={showAll} />
      </Popover>
    </>
  );
};

export default OrganizationSelect;
